
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import Pagination from "@/comp/Pagination/index.vue";
import { blackList, addBlack, removeBlack } from "@/api/request/user";
import { Message, MessageBox } from "element-ui";

//组件
@Component({
  name: "BlackList",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;

  //请求数据
  private listQuery: any = {
    //页面数据
    page: 0,
    page_size: 20,

    //临时数据
    user_id_str: "",

    //筛选数据
    user_id: -1,
  };

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.user_id = Number(this.listQuery.user_id_str);

    //获取数据
    const { data } = await blackList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理添加
  private async handleAdd() {
    //清空数据
    this.addForm = {
      user_id: 0,
      user_id_str: "",
    };

    //显示界面
    this.addDialogVisible = true;
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //处理删除
  private handleDelete(row: any): void {
    //显示提示
    MessageBox.confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //处理删除操作
        await removeBlack({ id: row.id });

        //显示提示
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //--------------------------------- 审核 ---------------------------------
  //定义变量
  private addDialogVisible: boolean = false;

  //定义变量
  private addForm: any = {
    user_id: 0,
    user_id_str: "",
  };

  //处理关闭
  private handleCloseAdd(): void {
    //隐藏界面
    this.addDialogVisible = false;
  }

  //处理审核
  private async handleAddBlack() {
    //判断返回
    if (Number(this.addForm.user_id_str) == 0) return Message({ message: "请输入用户ID！", type: "error", duration: 5 * 1000 });

    //显示等待
    this.listLoading = true;

    //数据赋值
    this.addForm.user_id = Number(this.addForm.user_id_str);

    //修改审核状态
    await addBlack(this.addForm);

    //显示提示
    this.$message.success("添加成功");

    //隐藏对话框
    this.addDialogVisible = false;

    //加载列表
    this.getList();
  }
}
